/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationContactsGetContactResponse { 
    id?: string | null;
    name?: string | null;
    postalCode?: string | null;
    city?: string | null;
    isCustomer?: boolean;
    turnOver?: number;
    isArchived?: boolean;
}

